import { jsx as W } from "react/jsx-runtime";
import * as E from "react";
import { useLayoutEffect as V, useEffect as m, useContext as R, useState as G, useRef as M, useImperativeHandle as k, useMemo as w, memo as L, forwardRef as A } from "react";
import { createPortal as q } from "react-dom";
const $ = E.createContext(null);
function Q(e, t) {
  const n = Array.isArray(e) ? e[0] : e ? e.x : 0, r = Array.isArray(e) ? e[1] : e ? e.y : 0, o = Array.isArray(t) ? t[0] : t ? t.x : 0, i = Array.isArray(t) ? t[1] : t ? t.y : 0;
  return n === o && r === i;
}
function y(e, t) {
  if (e === t)
    return !0;
  if (!e || !t)
    return !1;
  if (Array.isArray(e)) {
    if (!Array.isArray(t) || e.length !== t.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!y(e[n], t[n]))
        return !1;
    return !0;
  } else if (Array.isArray(t))
    return !1;
  if (typeof e == "object" && typeof t == "object") {
    const n = Object.keys(e), r = Object.keys(t);
    if (n.length !== r.length)
      return !1;
    for (const o of n)
      if (!t.hasOwnProperty(o) || !y(e[o], t[o]))
        return !1;
    return !0;
  }
  return !1;
}
function K(e) {
  const t = e.clone();
  return t.pixelsToGLUnits = e.pixelsToGLUnits, t;
}
function O(e, t) {
  if (!e.getProjection)
    return;
  const n = e.getProjection(), r = t.getProjection();
  y(n, r) || t.setProjection(n);
}
function F(e) {
  return {
    longitude: e.center.lng,
    latitude: e.center.lat,
    zoom: e.zoom,
    pitch: e.pitch,
    bearing: e.bearing,
    padding: e.padding
  };
}
function j(e, t) {
  const n = t.viewState || t;
  let r = !1;
  if ("zoom" in n) {
    const o = e.zoom;
    e.zoom = n.zoom, r = r || o !== e.zoom;
  }
  if ("bearing" in n) {
    const o = e.bearing;
    e.bearing = n.bearing, r = r || o !== e.bearing;
  }
  if ("pitch" in n) {
    const o = e.pitch;
    e.pitch = n.pitch, r = r || o !== e.pitch;
  }
  if (n.padding && !e.isPaddingEqual(n.padding) && (r = !0, e.padding = n.padding), "longitude" in n && "latitude" in n) {
    const o = e.center;
    e.center = new o.constructor(n.longitude, n.latitude), r = r || o !== e.center;
  }
  return r;
}
const J = ["type", "source", "source-layer", "minzoom", "maxzoom", "filter", "layout"];
function U(e) {
  if (!e)
    return null;
  if (typeof e == "string" || ("toJS" in e && (e = e.toJS()), !e.layers))
    return e;
  const t = {};
  for (const r of e.layers)
    t[r.id] = r;
  const n = e.layers.map((r) => {
    let o = null;
    "interactive" in r && (o = Object.assign({}, r), delete o.interactive);
    const i = t[r.ref];
    if (i) {
      o = o || Object.assign({}, r), delete o.ref;
      for (const a of J)
        a in i && (o[a] = i[a]);
    }
    return o || r;
  });
  return { ...e, layers: n };
}
const D = { version: 8, sources: {}, layers: [] }, B = {
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  click: "onClick",
  dblclick: "onDblClick",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  mouseout: "onMouseOut",
  contextmenu: "onContextMenu",
  touchstart: "onTouchStart",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchcancel: "onTouchCancel"
}, P = {
  movestart: "onMoveStart",
  move: "onMove",
  moveend: "onMoveEnd",
  dragstart: "onDragStart",
  drag: "onDrag",
  dragend: "onDragEnd",
  zoomstart: "onZoomStart",
  zoom: "onZoom",
  zoomend: "onZoomEnd",
  rotatestart: "onRotateStart",
  rotate: "onRotate",
  rotateend: "onRotateEnd",
  pitchstart: "onPitchStart",
  pitch: "onPitch",
  pitchend: "onPitchEnd"
}, Z = {
  wheel: "onWheel",
  boxzoomstart: "onBoxZoomStart",
  boxzoomend: "onBoxZoomEnd",
  boxzoomcancel: "onBoxZoomCancel",
  resize: "onResize",
  load: "onLoad",
  render: "onRender",
  idle: "onIdle",
  remove: "onRemove",
  data: "onData",
  styledata: "onStyleData",
  sourcedata: "onSourceData",
  error: "onError"
}, Y = [
  "minZoom",
  "maxZoom",
  "minPitch",
  "maxPitch",
  "maxBounds",
  "projection",
  "renderWorldCopies"
], X = [
  "scrollZoom",
  "boxZoom",
  "dragRotate",
  "dragPan",
  "keyboard",
  "doubleClickZoom",
  "touchZoomRotate",
  "touchPitch"
];
class T {
  constructor(t, n, r) {
    this._map = null, this._internalUpdate = !1, this._inRender = !1, this._hoveredFeatures = null, this._deferredEvents = {
      move: !1,
      zoom: !1,
      pitch: !1,
      rotate: !1
    }, this._onEvent = (o) => {
      const i = this.props[Z[o.type]];
      i ? i(o) : o.type === "error" && console.error(o.error);
    }, this._onPointerEvent = (o) => {
      (o.type === "mousemove" || o.type === "mouseout") && this._updateHover(o);
      const i = this.props[B[o.type]];
      i && (this.props.interactiveLayerIds && o.type !== "mouseover" && o.type !== "mouseout" && (o.features = this._hoveredFeatures || this._queryRenderedFeatures(o.point)), i(o), delete o.features);
    }, this._onCameraEvent = (o) => {
      if (!this._internalUpdate) {
        const i = this.props[P[o.type]];
        i && i(o);
      }
      o.type in this._deferredEvents && (this._deferredEvents[o.type] = !1);
    }, this._MapClass = t, this.props = n, this._initialize(r);
  }
  get map() {
    return this._map;
  }
  get transform() {
    return this._renderTransform;
  }
  setProps(t) {
    const n = this.props;
    this.props = t;
    const r = this._updateSettings(t, n);
    r && this._createShadowTransform(this._map);
    const o = this._updateSize(t), i = this._updateViewState(t, !0);
    this._updateStyle(t, n), this._updateStyleComponents(t, n), this._updateHandlers(t, n), (r || o || i && !this._map.isMoving()) && this.redraw();
  }
  static reuse(t, n) {
    const r = T.savedMaps.pop();
    if (!r)
      return null;
    const o = r.map, i = o.getContainer();
    for (n.className = i.className; i.childNodes.length > 0; )
      n.appendChild(i.childNodes[0]);
    o._container = n;
    const a = o._resizeObserver;
    a && (a.disconnect(), a.observe(n)), r.setProps({ ...t, styleDiffing: !1 }), o.resize();
    const { initialViewState: s } = t;
    return s && (s.bounds ? o.fitBounds(s.bounds, { ...s.fitBoundsOptions, duration: 0 }) : r._updateViewState(s, !1)), o.isStyleLoaded() ? o.fire("load") : o.once("styledata", () => o.fire("load")), o._update(), r;
  }
  /* eslint-disable complexity,max-statements */
  _initialize(t) {
    const { props: n } = this, { mapStyle: r = D } = n, o = {
      ...n,
      ...n.initialViewState,
      accessToken: n.mapboxAccessToken || ee() || null,
      container: t,
      style: U(r)
    }, i = o.initialViewState || o.viewState || o;
    if (Object.assign(o, {
      center: [i.longitude || 0, i.latitude || 0],
      zoom: i.zoom || 0,
      pitch: i.pitch || 0,
      bearing: i.bearing || 0
    }), n.gl) {
      const u = HTMLCanvasElement.prototype.getContext;
      HTMLCanvasElement.prototype.getContext = () => (HTMLCanvasElement.prototype.getContext = u, n.gl);
    }
    const a = new this._MapClass(o);
    i.padding && a.setPadding(i.padding), n.cursor && (a.getCanvas().style.cursor = n.cursor), this._createShadowTransform(a);
    const s = a._render;
    a._render = (u) => {
      this._inRender = !0, s.call(a, u), this._inRender = !1;
    };
    const l = a._renderTaskQueue.run;
    a._renderTaskQueue.run = (u) => {
      l.call(a._renderTaskQueue, u), this._onBeforeRepaint();
    }, a.on("render", () => this._onAfterRepaint());
    const c = a.fire;
    a.fire = this._fireEvent.bind(this, c), a.on("resize", () => {
      this._renderTransform.resize(a.transform.width, a.transform.height);
    }), a.on("styledata", () => {
      this._updateStyleComponents(this.props, {}), O(a.transform, this._renderTransform);
    }), a.on("sourcedata", () => this._updateStyleComponents(this.props, {}));
    for (const u in B)
      a.on(u, this._onPointerEvent);
    for (const u in P)
      a.on(u, this._onCameraEvent);
    for (const u in Z)
      a.on(u, this._onEvent);
    this._map = a;
  }
  /* eslint-enable complexity,max-statements */
  recycle() {
    const n = this.map.getContainer().querySelector("[mapboxgl-children]");
    n == null || n.remove(), T.savedMaps.push(this);
  }
  destroy() {
    this._map.remove();
  }
  // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
  // render cycle, which is managed by Mapbox's animation loop.
  // This removes the synchronization issue caused by requestAnimationFrame.
  redraw() {
    const t = this._map;
    !this._inRender && t.style && (t._frame && (t._frame.cancel(), t._frame = null), t._render());
  }
  _createShadowTransform(t) {
    const n = K(t.transform);
    t.painter.transform = n, this._renderTransform = n;
  }
  /* Trigger map resize if size is controlled
     @param {object} nextProps
     @returns {bool} true if size has changed
   */
  _updateSize(t) {
    const { viewState: n } = t;
    if (n) {
      const r = this._map;
      if (n.width !== r.transform.width || n.height !== r.transform.height)
        return r.resize(), !0;
    }
    return !1;
  }
  // Adapted from map.jumpTo
  /* Update camera to match props
     @param {object} nextProps
     @param {bool} triggerEvents - should fire camera events
     @returns {bool} true if anything is changed
   */
  _updateViewState(t, n) {
    if (this._internalUpdate)
      return !1;
    const r = this._map, o = this._renderTransform, { zoom: i, pitch: a, bearing: s } = o, l = r.isMoving();
    l && (o.cameraElevationReference = "sea");
    const c = j(o, {
      ...F(r.transform),
      ...t
    });
    if (l && (o.cameraElevationReference = "ground"), c && n) {
      const u = this._deferredEvents;
      u.move = !0, u.zoom || (u.zoom = i !== o.zoom), u.rotate || (u.rotate = s !== o.bearing), u.pitch || (u.pitch = a !== o.pitch);
    }
    return l || j(r.transform, t), c;
  }
  /* Update camera constraints and projection settings to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateSettings(t, n) {
    const r = this._map;
    let o = !1;
    for (const i of Y)
      if (i in t && !y(t[i], n[i])) {
        o = !0;
        const a = r[`set${i[0].toUpperCase()}${i.slice(1)}`];
        a == null || a.call(r, t[i]);
      }
    return o;
  }
  /* Update map style to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if style is changed
   */
  _updateStyle(t, n) {
    if (t.cursor !== n.cursor && (this._map.getCanvas().style.cursor = t.cursor || ""), t.mapStyle !== n.mapStyle) {
      const { mapStyle: r = D, styleDiffing: o = !0 } = t, i = {
        diff: o
      };
      return "localIdeographFontFamily" in t && (i.localIdeographFontFamily = t.localIdeographFontFamily), this._map.setStyle(U(r), i), !0;
    }
    return !1;
  }
  /* Update fog, light and terrain to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateStyleComponents(t, n) {
    const r = this._map;
    let o = !1;
    return r.isStyleLoaded() && ("light" in t && r.setLight && !y(t.light, n.light) && (o = !0, r.setLight(t.light)), "fog" in t && r.setFog && !y(t.fog, n.fog) && (o = !0, r.setFog(t.fog)), "terrain" in t && r.setTerrain && !y(t.terrain, n.terrain) && (!t.terrain || r.getSource(t.terrain.source)) && (o = !0, r.setTerrain(t.terrain))), o;
  }
  /* Update interaction handlers to match props
     @param {object} nextProps
     @param {object} currProps
     @returns {bool} true if anything is changed
   */
  _updateHandlers(t, n) {
    var r, o;
    const i = this._map;
    let a = !1;
    for (const s of X) {
      const l = (r = t[s]) !== null && r !== void 0 ? r : !0, c = (o = n[s]) !== null && o !== void 0 ? o : !0;
      y(l, c) || (a = !0, l ? i[s].enable(l) : i[s].disable());
    }
    return a;
  }
  _queryRenderedFeatures(t) {
    const n = this._map, r = n.transform, { interactiveLayerIds: o = [] } = this.props;
    try {
      return n.transform = this._renderTransform, n.queryRenderedFeatures(t, {
        layers: o.filter(n.getLayer.bind(n))
      });
    } catch {
      return [];
    } finally {
      n.transform = r;
    }
  }
  _updateHover(t) {
    var n;
    const { props: r } = this;
    if (r.interactiveLayerIds && (r.onMouseMove || r.onMouseEnter || r.onMouseLeave)) {
      const i = t.type, a = ((n = this._hoveredFeatures) === null || n === void 0 ? void 0 : n.length) > 0, s = this._queryRenderedFeatures(t.point), l = s.length > 0;
      !l && a && (t.type = "mouseleave", this._onPointerEvent(t)), this._hoveredFeatures = s, l && !a && (t.type = "mouseenter", this._onPointerEvent(t)), t.type = i;
    } else
      this._hoveredFeatures = null;
  }
  _fireEvent(t, n, r) {
    const o = this._map, i = o.transform, a = typeof n == "string" ? n : n.type;
    return a === "move" && this._updateViewState(this.props, !1), a in P && (typeof n == "object" && (n.viewState = F(i)), this._map.isMoving()) ? (o.transform = this._renderTransform, t.call(o, n, r), o.transform = i, o) : (t.call(o, n, r), o);
  }
  // All camera manipulations are complete, ready to repaint
  _onBeforeRepaint() {
    const t = this._map;
    this._internalUpdate = !0;
    for (const r in this._deferredEvents)
      this._deferredEvents[r] && t.fire(r);
    this._internalUpdate = !1;
    const n = this._map.transform;
    t.transform = this._renderTransform, this._onAfterRepaint = () => {
      O(this._renderTransform, n), t.transform = n;
    };
  }
}
T.savedMaps = [];
function ee() {
  let e = null;
  if (typeof location < "u") {
    const t = /access_token=([^&\/]*)/.exec(location.search);
    e = t && t[1];
  }
  try {
    e = e || process.env.MapboxAccessToken;
  } catch {
  }
  try {
    e = e || process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
  } catch {
  }
  return e;
}
const te = [
  "setMaxBounds",
  "setMinZoom",
  "setMaxZoom",
  "setMinPitch",
  "setMaxPitch",
  "setRenderWorldCopies",
  "setProjection",
  "setStyle",
  "addSource",
  "removeSource",
  "addLayer",
  "removeLayer",
  "setLayerZoomRange",
  "setFilter",
  "setPaintProperty",
  "setLayoutProperty",
  "setLight",
  "setTerrain",
  "setFog",
  "remove"
];
function ne(e) {
  if (!e)
    return null;
  const t = e.map, n = {
    getMap: () => t,
    // Overwrite getters to use our shadow transform
    getCenter: () => e.transform.center,
    getZoom: () => e.transform.zoom,
    getBearing: () => e.transform.bearing,
    getPitch: () => e.transform.pitch,
    getPadding: () => e.transform.padding,
    getBounds: () => e.transform.getBounds(),
    project: (r) => {
      const o = t.transform;
      t.transform = e.transform;
      const i = t.project(r);
      return t.transform = o, i;
    },
    unproject: (r) => {
      const o = t.transform;
      t.transform = e.transform;
      const i = t.unproject(r);
      return t.transform = o, i;
    },
    // options diverge between mapbox and maplibre
    queryTerrainElevation: (r, o) => {
      const i = t.transform;
      t.transform = e.transform;
      const a = t.queryTerrainElevation(r, o);
      return t.transform = i, a;
    },
    queryRenderedFeatures: (r, o) => {
      const i = t.transform;
      t.transform = e.transform;
      const a = t.queryRenderedFeatures(r, o);
      return t.transform = i, a;
    }
  };
  for (const r of oe(t))
    !(r in n) && !te.includes(r) && (n[r] = t[r].bind(t));
  return n;
}
function oe(e) {
  const t = /* @__PURE__ */ new Set();
  let n = e;
  for (; n; ) {
    for (const r of Object.getOwnPropertyNames(n))
      r[0] !== "_" && typeof e[r] == "function" && r !== "fire" && r !== "setEventedParent" && t.add(r);
    n = Object.getPrototypeOf(n);
  }
  return Array.from(t);
}
const re = typeof document < "u" ? V : m, ie = [
  "baseApiUrl",
  "maxParallelImageRequests",
  "workerClass",
  "workerCount",
  "workerUrl"
];
function ae(e, t) {
  for (const r of ie)
    r in t && (e[r] = t[r]);
  const { RTLTextPlugin: n = "https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js" } = t;
  n && e.getRTLTextPluginStatus && e.getRTLTextPluginStatus() === "unavailable" && e.setRTLTextPlugin(n, (r) => {
    r && console.error(r);
  }, !0);
}
const z = E.createContext(null);
function se(e, t, n) {
  const r = R($), [o, i] = G(null), a = M(), { current: s } = M({ mapLib: null, map: null });
  m(() => {
    const u = e.mapLib;
    let v = !0, h;
    return Promise.resolve(u || n).then((p) => {
      if (!v)
        return;
      if (!p)
        throw new Error("Invalid mapLib");
      const d = "Map" in p ? p : p.default;
      if (!d.Map)
        throw new Error("Invalid mapLib");
      if (ae(d, e), !d.supported || d.supported(e))
        e.reuseMaps && (h = T.reuse(e, a.current)), h || (h = new T(d.Map, e, a.current)), s.map = ne(h), s.mapLib = d, i(h), r == null || r.onMapMount(s.map, e.id);
      else
        throw new Error("Map is not supported by this browser");
    }).catch((p) => {
      const { onError: d } = e;
      d ? d({
        type: "error",
        target: null,
        originalEvent: null,
        error: p
      }) : console.error(p);
    }), () => {
      v = !1, h && (r == null || r.onMapUnmount(e.id), e.reuseMaps ? h.recycle() : h.destroy());
    };
  }, []), re(() => {
    o && o.setProps(e);
  }), k(t, () => s.map, [o]);
  const l = w(() => ({
    position: "relative",
    width: "100%",
    height: "100%",
    ...e.style
  }), [e.style]), c = {
    height: "100%"
  };
  return E.createElement("div", { id: e.id, ref: a, style: l }, o && E.createElement(
    z.Provider,
    { value: s },
    E.createElement("div", { "mapboxgl-children": "", style: c }, e.children)
  ));
}
const ce = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function S(e, t) {
  if (!e || !t)
    return;
  const n = e.style;
  for (const r in t) {
    const o = t[r];
    Number.isFinite(o) && !ce.test(r) ? n[r] = `${o}px` : n[r] = o;
  }
}
function le(e, t) {
  const { map: n, mapLib: r } = R(z), o = M({ props: e });
  o.current.props = e;
  const i = w(() => {
    let N = !1;
    E.Children.forEach(e.children, (_) => {
      _ && (N = !0);
    });
    const I = {
      ...e,
      element: N ? document.createElement("div") : null
    }, b = new r.Marker(I);
    return b.setLngLat([e.longitude, e.latitude]), b.getElement().addEventListener("click", (_) => {
      var g, f;
      (f = (g = o.current.props).onClick) === null || f === void 0 || f.call(g, {
        type: "click",
        target: b,
        originalEvent: _
      });
    }), b.on("dragstart", (_) => {
      var g, f;
      const C = _;
      C.lngLat = i.getLngLat(), (f = (g = o.current.props).onDragStart) === null || f === void 0 || f.call(g, C);
    }), b.on("drag", (_) => {
      var g, f;
      const C = _;
      C.lngLat = i.getLngLat(), (f = (g = o.current.props).onDrag) === null || f === void 0 || f.call(g, C);
    }), b.on("dragend", (_) => {
      var g, f;
      const C = _;
      C.lngLat = i.getLngLat(), (f = (g = o.current.props).onDragEnd) === null || f === void 0 || f.call(g, C);
    }), b;
  }, []);
  m(() => (i.addTo(n.getMap()), () => {
    i.remove();
  }), []);
  const { longitude: a, latitude: s, offset: l, style: c, draggable: u = !1, popup: v = null, rotation: h = 0, rotationAlignment: p = "auto", pitchAlignment: d = "auto" } = e;
  return m(() => {
    S(i.getElement(), c);
  }, [c]), k(t, () => i, []), (i.getLngLat().lng !== a || i.getLngLat().lat !== s) && i.setLngLat([a, s]), l && !Q(i.getOffset(), l) && i.setOffset(l), i.isDraggable() !== u && i.setDraggable(u), i.getRotation() !== h && i.setRotation(h), i.getRotationAlignment() !== p && i.setRotationAlignment(p), i.getPitchAlignment() !== d && i.setPitchAlignment(d), i.getPopup() !== v && i.setPopup(v), q(e.children, i.getElement());
}
const Se = L(A(le));
function H(e) {
  return new Set(e ? e.trim().split(/\s+/) : []);
}
function ue(e, t) {
  const { map: n, mapLib: r } = R(z), o = w(() => document.createElement("div"), []), i = M({ props: e });
  i.current.props = e;
  const a = w(() => {
    const s = { ...e }, l = new r.Popup(s);
    return l.setLngLat([e.longitude, e.latitude]), l.once("open", (c) => {
      var u, v;
      (v = (u = i.current.props).onOpen) === null || v === void 0 || v.call(u, c);
    }), l;
  }, []);
  if (m(() => {
    const s = (l) => {
      var c, u;
      (u = (c = i.current.props).onClose) === null || u === void 0 || u.call(c, l);
    };
    return a.on("close", s), a.setDOMContent(o).addTo(n.getMap()), () => {
      a.off("close", s), a.isOpen() && a.remove();
    };
  }, []), m(() => {
    S(a.getElement(), e.style);
  }, [e.style]), k(t, () => a, []), a.isOpen() && ((a.getLngLat().lng !== e.longitude || a.getLngLat().lat !== e.latitude) && a.setLngLat([e.longitude, e.latitude]), e.offset && !y(a.options.offset, e.offset) && a.setOffset(e.offset), (a.options.anchor !== e.anchor || a.options.maxWidth !== e.maxWidth) && (a.options.anchor = e.anchor, a.setMaxWidth(e.maxWidth)), a.options.className !== e.className)) {
    const s = H(a.options.className), l = H(e.className);
    for (const c of s)
      l.has(c) || a.removeClassName(c);
    for (const c of l)
      s.has(c) || a.addClassName(c);
    a.options.className = e.className;
  }
  return q(e.children, o);
}
const fe = L(A(ue));
function x(e, t, n, r) {
  const o = R(z), i = w(() => e(o), []);
  return m(() => {
    const a = t, s = null, l = typeof t == "function" ? t : null, { map: c } = o;
    return c.hasControl(i) || (c.addControl(i, a == null ? void 0 : a.position), s && s(o)), () => {
      l && l(o), c.hasControl(i) && c.removeControl(i);
    };
  }, []), i;
}
function de(e) {
  const t = x(({ mapLib: n }) => new n.AttributionControl(e), {
    position: e.position
  });
  return m(() => {
    S(t._container, e.style);
  }, [e.style]), null;
}
L(de);
function me(e) {
  const t = x(({ mapLib: n }) => new n.FullscreenControl({
    container: e.containerId && document.getElementById(e.containerId)
  }), { position: e.position });
  return m(() => {
    S(t._controlContainer, e.style);
  }, [e.style]), null;
}
L(me);
function he(e, t) {
  const n = M({ props: e }), r = x(({ mapLib: o }) => {
    const i = new o.GeolocateControl(e), a = i._setupUI;
    return i._setupUI = (s) => {
      i._container.hasChildNodes() || a(s);
    }, i.on("geolocate", (s) => {
      var l, c;
      (c = (l = n.current.props).onGeolocate) === null || c === void 0 || c.call(l, s);
    }), i.on("error", (s) => {
      var l, c;
      (c = (l = n.current.props).onError) === null || c === void 0 || c.call(l, s);
    }), i.on("outofmaxbounds", (s) => {
      var l, c;
      (c = (l = n.current.props).onOutOfMaxBounds) === null || c === void 0 || c.call(l, s);
    }), i.on("trackuserlocationstart", (s) => {
      var l, c;
      (c = (l = n.current.props).onTrackUserLocationStart) === null || c === void 0 || c.call(l, s);
    }), i.on("trackuserlocationend", (s) => {
      var l, c;
      (c = (l = n.current.props).onTrackUserLocationEnd) === null || c === void 0 || c.call(l, s);
    }), i;
  }, { position: e.position });
  return n.current.props = e, k(t, () => r, []), m(() => {
    S(r._container, e.style);
  }, [e.style]), null;
}
L(A(he));
function ge(e) {
  const t = x(({ mapLib: n }) => new n.NavigationControl(e), {
    position: e.position
  });
  return m(() => {
    S(t._container, e.style);
  }, [e.style]), null;
}
const Me = L(ge);
function pe(e) {
  const t = x(({ mapLib: i }) => new i.ScaleControl(e), {
    position: e.position
  }), n = M(e), r = n.current;
  n.current = e;
  const { style: o } = e;
  return e.maxWidth !== void 0 && e.maxWidth !== r.maxWidth && (t.options.maxWidth = e.maxWidth), e.unit !== void 0 && e.unit !== r.unit && t.setUnit(e.unit), m(() => {
    S(t._container, o);
  }, [o]), null;
}
L(pe);
const ve = "_popup_1gr3c_35", _e = {
  "map-container": "_map-container_1gr3c_29",
  popup: ve,
  "center-marker": "_center-marker_1gr3c_41"
}, ye = import("./__vite-optional-peer-dep_mapbox-gl_react-map-gl-DYxpcVy9.js");
E.forwardRef(function(t, n) {
  return se(t, n, ye);
});
const Ce = fe, Te = ({ longitude: e, latitude: t, content: n, offset: r }) => /* @__PURE__ */ W(
  Ce,
  {
    longitude: e,
    latitude: t,
    closeButton: !1,
    closeOnClick: !1,
    anchor: "bottom",
    offset: r,
    className: _e.popup,
    children: n
  }
);
export {
  z as M,
  Te as P,
  Me as _,
  se as a,
  Se as b,
  y as d,
  _e as s
};
